import { NavLink } from "react-router";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, Card } from "@mui/material";

export function Pages() {
    return (
        <div className="p-8">
            <a href="/" className="absolute top-4 left-4">
                <ArrowBackIcon />
            </a>
            <Card variant="outlined" className="flex justify-center items-center gap-8 mb-8 p-4">
                <Button href="https://www.youtube.com/watch?v=fyeKEzdrgYg" target="_blank" rel="noopener noreferrer" variant="outlined" className="px-4 py-2 transition">
                    Code100 2023 (got 2nd place 🏆)
                </Button>
                <NavLink to="/lh-3rd-party">
                    <Button variant="outlined" className="px-4 py-2 transition">
                        Lighthouse 3rd Party Visualization
                    </Button>
                </NavLink>
            </Card>
        </div>
    );
}

export default Pages;
